import React, { useEffect, useState } from "react";
import { BASE_API_URL } from "../../services/baseServices";
import Swal from 'sweetalert2';
import axios from "axios";
import { Select } from 'antd';
import ReactQuill from 'react-quill';
import { GET_DDL_ITEMS } from "../../services/commonServices";
import { ADD_PRODUCT } from "../../services/productServices";


export default function AddProduct() {

    const { Option } = Select;
    const [sessionUserData, setSessionUserData] = useState({});
    const [image, setImage] = useState(null);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [categoriesData, setCategoriesData] = useState([]);
    const [imagePreview, setImagePreview] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setSessionUserData(userData);
        } else {
            console.log('');
        }
    }, []);

    const [formData, setFormData] = useState({
        OrgId: sessionUserData?.OrgId,
        SubCategoryId: '1',
        ProductName: '',
        ProductCode: '',
        Description: '',
        Brand: '',
        CreatedBy: sessionUserData?.Id,
        IsActive: '1',
    });

    const fetchDDLItems = async (type) => {
        try {
            const response = await axios.get(`${BASE_API_URL}${GET_DDL_ITEMS}?OrgId=${sessionUserData?.OrgId}&UserId=${sessionUserData?.Id}`);
            const allItems = response.data.ResultData;
            
            const categoriesResponse = allItems.filter(item => item.DDLName === "Categories");
            setCategoriesData(categoriesResponse);
        } catch (error) {
            console.error(`Error fetching ${type}:`, error);
            return null;
        }
    };
    
    useEffect(() => {
        if (sessionUserData?.OrgId) {
            fetchDDLItems();
        }
    }, [sessionUserData]);
    
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setImage(file);
    
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            setImagePreview(null);
        }
    };
    
    const handleRemoveImage = () => {
        setImage(null);
        setImagePreview(null);
    };    

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        const data = new FormData();

        for (const key in formData) {
            data.append(key, formData[key]);
        }

        if (image) {
            data.append('ImageUrl', image);
        }
        
        if (selectedCategoryId) {
            data.append('CategoryId', selectedCategoryId);
        }

        for (let pair of data.entries()) {
            console.log(`${pair[0]}: ${pair[1]}`);
        }
        
        try {
            const response = await axios.post(
                `${BASE_API_URL}${ADD_PRODUCT}`,
                data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            const result = response.data;
            console.log('Success:', result.output);
            if(result.output.Status === 'Success') {
                setSubmitLoading(false);
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Product added successfully!',
                }).then(() => {
                    window.location.reload();
                })
            }
        } catch (error) {
            setSubmitLoading(false);
            console.error('Error uploading product:', error);
            Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: 'Failed to add product.',
            });
        }
    };

    return (
        <div
            className="offcanvas offcanvas-end"
            tabIndex="-1"
            id="offcanvasRightAdd"
            aria-labelledby="offcanvasRightLabel"
            style={{ minWidth: "45%", maxWidth: "45%" }}
        >
            <form autoComplete="off" onSubmit={handleSubmit}>
                <div className="offcanvas-header d-flex justify-content-between align-items-center">
                    <h5 id="offcanvasRightLabel" className="mb-0">Add Product</h5>
                    <div className="d-flex align-items-center">
                        <button 
                            className="btn btn-primary p-2 rounded w-full me-2"
                            type="submit"
                            disabled={submitLoading}
                        >
                            {submitLoading ? 'Submitting...' : 'Submit'}
                        </button>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ></button>
                    </div>
                </div>
                <div 
                    className="offcanvas-body" 
                    style={{
                        // flex: 1,
                        minHeight: '33rem',
                        overflowY: 'auto',
                        paddingBottom: '2rem',
                        // maxHeight: 'calc(100vh - 100px)'
                    }}
                >
                    <div className="row">
                        <div className="col-12 mb-2 col-md-6">
                            <label className="form-label">Name <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="ProductName"
                                placeholder="Enter Product Name"
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="col-12 mb-2 col-md-6">
                            <label className="form-label">Code <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="ProductCode"
                                placeholder="Enter Product Code"
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="col-12 mb-2 col-md-6">
                            <label className="form-label">Brand <span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="Brand"
                                placeholder="Enter Brand"
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="" style={{ flex: 1 }}>
                            <label className="form-label">Category <span className="text-danger">*</span></label>
                            <Select
                                showSearch
                                allowClear
                                placeholder="Choose Category"
                                optionFilterProp="children"
                                style={{ width: '100%', height: 42 }}
                                onChange={(value) => setSelectedCategoryId(value)}
                                filterOption={(input, option) =>
                                    (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {categoriesData && categoriesData?.map((item) => (
                                    <Option key={item.ItemId} value={item.ItemId}>
                                        {item.ItemValue}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className="col-12 mb-2 col-md-6">
                            <label className="form-label">Image <span className="text-danger">*</span></label>
                            <input
                                type="file"
                                className="form-control"
                                name="ImageUrl"
                                placeholder="Enter Description"
                                accept="image/*"
                                onChange={handleImageChange}
                                required
                            />
                        </div>
                        <div className="col-12 mb-2">
                            <label className="form-label">Description <span className="text-danger">*</span></label>
                            <ReactQuill
                                theme="snow"
                                value={formData.Description}
                                onChange={(value) => setFormData({ ...formData, Description: value })}
                                placeholder="Enter description..."
                                style={{ height: '100px' }}
                            />
                        </div>
                    </div>
                </div>
            </form>

            {imagePreview && (
                <div className="col-12 mb-3 position-relative p-7" style={{ width: "280px", height: "280px" }}>
                    <label className="form-label">Image Preview</label>
                    <div className="position-relative" style={{ width: "100%", height: "100%" }}>
                        <img
                            src={imagePreview}
                            alt="Preview"
                            className="rounded border"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "0.5rem"
                            }}
                        />
                        <button
                            type="button"
                            onClick={handleRemoveImage}
                            className="btn btn-sm text-danger fw-bold position-absolute"
                            style={{
                                top: "0",
                                right: "0",
                                zIndex: "10",
                                background: "white",
                                border: "none",
                                borderRadius: "0 0 0 0.5rem",
                                padding: "0.25rem 0.5rem",
                                cursor: "pointer",
                            }}
                            aria-label="Remove image"
                        >
                            X
                        </button>
                    </div>
                </div>
            )}

        </div>
    );
}
